import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Clock } from "lucide-react";

export default function AccountExpired() {
  const { accountBlocked } = useAuth();
  const message = accountBlocked || "Masa aktif akun Anda telah habis.";

  return (
    <div className="min-h-screen grid place-items-center p-6">
      <Card className="max-w-md w-full p-8 rounded-2xl text-center" data-testid="account-expired-page">
        <div className="h-12 w-12 mx-auto rounded-full bg-amber-500/15 grid place-items-center mb-4">
          <Clock className="h-6 w-6 text-amber-600" />
        </div>
        <h1 className="font-serif text-3xl mb-3">Masa Aktif Habis</h1>
        <p className="text-muted-foreground text-sm leading-relaxed mb-6" data-testid="account-expired-message">
          {message}
        </p>
        <div className="rounded-xl border border-border bg-muted/40 p-4 text-sm text-left mb-6">
          <p className="font-medium mb-1">Data Anda belum hilang.</p>
          <p className="text-muted-foreground">
            Hubungi admin Weddly untuk memperpanjang masa aktif akun Anda. Akun yang diarsipkan masih
            bisa dipulihkan.
          </p>
        </div>
        <Button
          variant="ghost"
          className="rounded-full"
          onClick={() => {
            window.location.href = "/login";
          }}
        >
          Kembali ke Halaman Login
        </Button>
      </Card>
    </div>
  );
}
